// Pixel-art avatars, drawn on a 10×10 grid so they stay crisp at 16px. Each
// letter in a row maps to a colour in the palette; '.' is transparent (the
// tile shows through). Keys must match users/avatars.py on the backend.
export const CRITTERS = {
  robot: {
    label: 'Robot', tile: '#4f46e5',
    palette: { S: '#e2e8f0', C: '#67e8f9', D: '#312e81', A: '#fbbf24' },
    rows: ['....AA....', '....SS....', '.SSSSSSSS.', '.SSSSSSSS.', '.SCCSSCCS.', '.SCCSSCCS.', '.SSSSSSSS.', '.SDDDDDDS.', '.SSSSSSSS.', '..SS..SS..'],
  },
  fox: {
    label: 'Fox', tile: '#bae6fd',
    palette: { O: '#f97316', W: '#ffffff', d: '#1c1917' },
    rows: ['.O......O.', '.OO....OO.', '.OOOOOOOO.', '.OOOOOOOO.', '.OdOOOOdO.', '.OOOWWOOO.', '..OWWWWO..', '...WddW...', '....WW....', '..........'],
  },
  owl: {
    label: 'Owl', tile: '#064e3b',
    palette: { T: '#f59e0b', F: '#fef3c7', D: '#1c1917', B: '#ea580c' },
    rows: ['.T......T.', '.TT....TT.', '.TTTTTTTT.', '.TFFTTFFT.', '.TFDTTDFT.', '.TTTBBTTT.', '.TTTTTTTT.', '..TTTTTT..', '...TTTT...', '..........'],
  },
  penguin: {
    label: 'Penguin', tile: '#fbbf24',
    palette: { K: '#0f172a', W: '#f8fafc', Y: '#f97316' },
    rows: ['...KKKK...', '..KKKKKK..', '.KKWKKWKK.', '.KKKKKKKK.', '.KKKYYKKK.', '.KKWWWWKK.', '.KKWWWWKK.', '.KKWWWWKK.', '..KKKKKK..', '..YY..YY..'],
  },
  cat: {
    label: 'Cat', tile: '#fbcfe8',
    palette: { K: '#111827', G: '#4ade80', P: '#f472b6' },
    rows: ['.K......K.', '.KK....KK.', '.KKKKKKKK.', '.KKKKKKKK.', '.KGKKKKGK.', '.KKKKKKKK.', '.KKKPPKKK.', '..KKKKKK..', '...KKKK...', '..........'],
  },
  dog: {
    label: 'Dog', tile: '#fde68a',
    palette: { B: '#b45309', E: '#78350f', W: '#fff7ed', d: '#1c1917' },
    rows: ['..BBBBBB..', '.EBBBBBBE.', '.EBBBBBBE.', '.EBdBBdBE.', '.EBBBBBBE.', '..BBWWBB..', '..BWWWWB..', '...WddW...', '....WW....', '..........'],
  },
  bear: {
    label: 'Bear', tile: '#a7f3d0',
    palette: { B: '#92400e', M: '#fcd34d', d: '#1c1917' },
    rows: ['.BB....BB.', '.BB....BB.', '.BBBBBBBB.', 'BBBBBBBBBB', 'BBdBBBBdBB', 'BBBBMMBBBB', '.BBMMMMBB.', '.BBMddMBB.', '..BBBBBB..', '..........'],
  },
  frog: {
    label: 'Frog', tile: '#fda4af',
    palette: { G: '#22c55e', d: '#1c1917', D: '#166534' },
    rows: ['.GG....GG.', '.GdG..GdG.', '.GGGGGGGG.', 'GGGGGGGGGG', 'GGGGGGGGGG', 'GGGGGGGGGG', '.GDDDDDDG.', '.GGGGGGGG.', '..GGGGGG..', '..........'],
  },
  ghost: {
    label: 'Ghost', tile: '#a855f7',
    palette: { W: '#f8fafc', d: '#1c1917' },
    rows: ['...WWWW...', '..WWWWWW..', '.WWWWWWWW.', '.WWdWWdWW.', '.WWWWWWWW.', '.WWWWWWWW.', '.WWWWWWWW.', '.WWWWWWWW.', '.WWWWWWWW.', '.W.WWWW.W.'],
  },
  dino: {
    label: 'Dino', tile: '#fecaca',
    palette: { G: '#15803d', d: '#fef3c7' },
    rows: ['.....GGGG.', '.....GdGG.', '.....GGGG.', '.....GGG..', 'G...GGGGG.', 'GG.GGGGG..', '.GGGGGGG..', '..GGGGGG..', '...GG.GG..', '...G...G..'],
  },
  alien: {
    label: 'Alien', tile: '#1e293b',
    palette: { A: '#4ade80', d: '#0f172a' },
    rows: ['...AAAA...', '..AAAAAA..', '.AAAAAAAA.', '.AddAAddA.', '.AddAAddA.', '.AAAAAAAA.', '..AAAAAA..', '...AAAA...', '....AA....', '..........'],
  },
  mushroom: {
    label: 'Mushroom', tile: '#bbf7d0',
    palette: { R: '#ef4444', W: '#ffffff', S: '#fef3c7', d: '#1c1917' },
    rows: ['...RRRR...', '..RWRRWR..', '.RRRRRRRR.', '.RWRRRRWR.', 'RRRRRRRRRR', 'RRRRRRRRRR', '...SSSS...', '...SdSdS..', '...SSSS...', '...SSSS...'],
  },
};

export const CRITTER_KEYS = Object.keys(CRITTERS);
